import { motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";

export const LangSwitch = ({ idPrefix = "nav" }) => {
  const { lang, setLang } = useLang();
  return (
    <div dir="ltr" role="group" aria-label="Language" className="relative flex h-10 items-center rounded-full border border-noor-pearl/15 bg-noor-ink/40 p-1">
      {/* A single sliding pill instead of a shared layoutId: layout projection inside the
          mobile menu's AnimatePresence never reports exit completion after a language change. */}
      <motion.span
        aria-hidden="true"
        data-testid={`${idPrefix}-lang-pill`}
        className="pointer-events-none absolute left-1 top-1 h-8 w-10 rounded-full bg-noor-champagne"
        initial={false}
        animate={{ x: lang === "en" ? "100%" : "0%" }}
        transition={{ type: "spring", stiffness: 380, damping: 30 }}
      />
      {["fa", "en"].map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`${idPrefix}-lang-${l}`}
          aria-pressed={lang === l}
          onClick={() => setLang(l)}
          className={`relative z-10 h-8 w-10 rounded-full text-xs font-semibold transition-colors duration-300 ${lang === l ? "text-noor-deep" : "text-noor-pearl/75 hover:text-noor-pearl"}`}
        >
          {l === "fa" ? "FA" : "EN"}
        </button>
      ))}
    </div>
  );
};
